export const getUserConsultBlockUrl = (baseUrl: string) => {
  const userConsultBlockUrl = `${baseUrl}/user/consult-blocks`
  return {
    GET_USER_CONSULT_BLOCK_LIST: (user_id: number) => `${userConsultBlockUrl}/${user_id}/now-blocks`,
    GET_BLOCK_STEP_LIST: (user_id: number, block_id: number) =>
      `${userConsultBlockUrl}/${user_id}/now-blocks/${block_id}/steps`,
    GET_MY_STEPS_BY_LATEST_BLOCK: () => `${userConsultBlockUrl}/steps`
  }
}
